export enum MessageSeverity {
    Critical = <any>"critical",
    Warning = <any>"warning",
    Informational = <any>"informational"
}

export class Message {
    public id: any;
    public severity: MessageSeverity;
    public title: string;
    public value: any;

    constructor(message?: any) {
        this.id = message && message.id || null;
        this.severity = message && message.severity || null;
        this.title = message && message.title || null;
        this.value = message && message.value || null;
    }
}
